import React, { useEffect, useState } from 'react';
import './PressKit.css';
import cover from '../../assets/coverart/Tiefseetauchen.jpg';
import artistPhoto from '../../assets/press/Foto_pr_kit.jpg';
import logo from '../../assets/logomondwild.png';
import youtube from '../../assets/socialmedia/youtube.png';
import spotify from '../../assets/socialmedia/spotify.png';
import instagram from '../../assets/socialmedia/instagram.png';
import applemusic from '../../assets/socialmedia/applemusic.png';
import tidal from '../../assets/socialmedia/tidal.png';
import bandcamp from '../../assets/socialmedia/bandcamp.png';

const DRIVE = {
  photos: 'https://drive.google.com/drive/folders/1xJD2tX5Uupsksus45fhwXhzDb_lenx1r?usp=sharing',
  logo: 'https://drive.google.com/drive/folders/1WdyQCCwyP0DJTvR95zWkQB3qB2pG1HCR?usp=sharing',
  cover: 'https://drive.google.com/file/d/1U85-KqxQNG5pS25fj2gAVXilZiACqwbK/view?usp=sharing',
  mp3: 'https://drive.google.com/file/d/1GQ_uKEGz1xxmcVSxObFJEWzk-ZpCl2Sh/view?usp=sharing',
  wav: 'https://drive.google.com/file/d/1IyQ7RhCV6ikN0NL9kL2poxsGLopr-75Q/view?usp=sharing',
  lyrics: 'https://drive.google.com/file/d/1zaorsuGdZiW6-ydmRIxmpwYcvMkzKEB5/view?usp=sharing',
  prPdf: 'https://drive.google.com/file/d/1PEyyUPr309YAXD7R7JBxPZqqvOIaGJC-/view?usp=sharing',
  labelcopy: 'https://drive.google.com/file/d/1r-A4vDp6FBeYcRhwNgQvhO7ScIt9hH__/view?usp=sharing',
};

const PR_HEADLINE =
  'Eine tanzbare Reise unter die Oberfläche | MondWild veröffentlicht neue Single „Tiefseetauchen“';

const PR_BODY = `Was passiert, wenn elektronische Euphorie auf den Mut trifft, sich selbst wirklich zu begegnen? Mit ihrer neuen Single „Tiefseetauchen“ verbindet MondWild atmosphärischen Dream House mit deutschsprachigem, poetischem Storytelling – und macht aus einer Reise nach innen einen Song, zu dem man trotzdem tanzen will.

Die Münchner Musikerin, Produzentin und Yogalehrerin hat sich mit diesem Kontrast einen eigenen Sound gebaut: intime Lyrics und eine klare, sensible Stimme treffen auf elektronische Weite, pulsierende Beats und euphorische Momente. Im vergangenen Sommer brachte sie ihre Musik unter anderem beim StuStaCulum und Isarinselfest in München sowie beim Alles Gute Festival in Innsbruck live auf die Bühne. Seit 2025 veröffentlicht sie kontinuierlich eigene Musik und ist Teil des Sprungbrett-Förderprogramms der Feierwerk Fachstelle Pop München. Berlin on Air beschrieb ihren Sound als „einen wirklich innovativen Elektrosound mit einem starken Wiedererkennungswert“.

In „Tiefseetauchen“ wird das Abtauchen zum Bild für Selbstbegegnung: für den Moment, in dem man nicht mehr an der Oberfläche bleibt, sondern sich traut, tiefer zu gehen – ohne Garantie, wer man danach sein wird. „Wir könnten auch Tiefseetauchen / ohne Garantie / wer wir beim Auftauchen sind“ heißt es im Refrain. Uhren verschwinden, Nebel zieht auf, und am Ende trägt die Person, die wieder auftaucht, das Meer noch auf der Haut.

Der Song romantisiert diesen Weg nicht: Sich selbst wirklich zuzuhören kann beängstigend sein, gerade weil dabei Sicherheiten und alte Selbstbilder ins Wanken geraten. Gleichzeitig liegt genau darin die Lebendigkeit, die MondWilds Musik ausmacht – der Mut, unter die Oberfläche zu gehen und der eigenen inneren Richtung zu folgen.

Mit „Tiefseetauchen“ verdichtet MondWild ihre Idee von Dream House weiter: euphorisch-introspektive elektronische Musik für sensible Freigeister – zwischen Tiefe und Tanzbarkeit, MOND und WILD.`;

const PR_FULL = `${PR_HEADLINE}

${PR_BODY}`;

const socials = [
  { href: 'https://www.instagram.com/mondwild/', src: instagram, alt: 'Instagram' },
  { href: 'https://open.spotify.com/artist/6s96d678Hgy10yUb32I0GT', src: spotify, alt: 'Spotify' },
  { href: 'https://www.youtube.com/@mondwild', src: youtube, alt: 'YouTube' },
  { href: 'https://music.apple.com/de/artist/mondwild/1870810851', src: applemusic, alt: 'Apple Music' },
  { href: 'https://tidal.com/artist/73373166', src: tidal, alt: 'Tidal' },
  { href: 'https://mondwild.bandcamp.com/', src: bandcamp, alt: 'Bandcamp' },
];

const IconDownload = () => (
  <svg className="pk-dl-icon" viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      d="M12 3v12m0 0l-4-4m4 4l4-4M5 21h14"
    />
  </svg>
);

const CopyButton = ({ text, label = 'Text kopieren' }) => {
  const [copied, setCopied] = useState(false);

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2200);
    } catch {
      setCopied(false);
    }
  };

  return (
    <button type="button" className="pk-copy" onClick={onCopy}>
      {copied ? 'Kopiert' : label}
    </button>
  );
};

export const PressKit = () => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'Presse · Tiefseetauchen – MondWild';

    const robots = document.createElement('meta');
    robots.name = 'robots';
    robots.content = 'noindex, nofollow, noarchive';
    document.head.appendChild(robots);

    return () => {
      document.title = previousTitle;
      robots.remove();
    };
  }, []);

  return (
    <div className="pk">
      <header className="pk-top">
        <a href="/" className="pk-brand" aria-label="MondWild Website">
          <img src={logo} alt="MondWild" />
        </a>
        <p className="pk-eyebrow">Pressekit</p>
      </header>

      <section className="pk-hero">
        <a
          className="pk-cover-wrap"
          href={DRIVE.cover}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={cover} alt="Coverart Tiefseetauchen – MondWild" />
        </a>

        <div className="pk-hero-copy">
          <p className="pk-kicker">Neue Single von MondWild · Release 9. Oktober 2026</p>
          <h1>Tiefseetauchen</h1>
          <p className="pk-lead">
            Eine tanzbare Reise unter die Oberfläche. Dream House mit
            deutschsprachigem Storytelling – zwischen Tiefe und Tanzbarkeit.
          </p>

          <dl className="pk-facts">
            <div>
              <dt>Artist</dt>
              <dd>MondWild</dd>
            </div>
            <div>
              <dt>Label</dt>
              <dd>Regentänzer</dd>
            </div>
            <div>
              <dt>Länge</dt>
              <dd>4:17</dd>
            </div>
            <div>
              <dt>ISRC</dt>
              <dd>DEAR42662726</dd>
            </div>
            <div>
              <dt>EAN</dt>
              <dd>4070169602243</dd>
            </div>
            <div>
              <dt>Genre</dt>
              <dd>Prog-House / Dream House</dd>
            </div>
          </dl>

          <div className="pk-audio">
            <a className="pk-btn pk-btn-primary" href={DRIVE.wav} target="_blank" rel="noopener noreferrer">
              Jetzt hören (WAV) →
            </a>
            <a className="pk-btn" href={DRIVE.mp3} target="_blank" rel="noopener noreferrer">
              MP3
            </a>
          </div>

          <div className="pk-socials">
            {socials.map(({ href, src, alt }) => (
              <a key={alt} href={href} target="_blank" rel="noopener noreferrer" title={alt}>
                <img src={src} alt={alt} />
              </a>
            ))}
          </div>
        </div>
      </section>

      <blockquote className="pk-quote">
        „Wir könnten auch Tiefseetauchen ohne Garantie, wer wir beim Auftauchen sind.“
      </blockquote>

      <section className="pk-section">
        <div className="pk-pr-grid">
          <div>
            <div className="pk-section-head">
              <h2>PR-Text</h2>
              <div className="pk-section-actions">
                <CopyButton text={PR_FULL} />
                <a className="pk-textlink" href={DRIVE.prPdf} target="_blank" rel="noopener noreferrer">
                  als PDF
                </a>
              </div>
            </div>
            <article className="pk-prose">
              <h3>{PR_HEADLINE}</h3>
              {PR_BODY.split('\n\n').map((paragraph) => (
                <p key={paragraph.slice(0, 40)}>{paragraph}</p>
              ))}
            </article>
          </div>
          <figure className="pk-artist">
            <a href={DRIVE.photos} target="_blank" rel="noopener noreferrer">
              <img src={artistPhoto} alt="MondWild live am Controller" />
            </a>
            <figcaption>MondWild · Foto: Rodrigo Klemens Wulfhorst</figcaption>
          </figure>
        </div>
      </section>

      <section className="pk-bottom">
        <div>
          <div className="pk-section-head">
            <h2>Lyrics</h2>
            <a className="pk-textlink" href={DRIVE.lyrics} target="_blank" rel="noopener noreferrer">
              als PDF
            </a>
          </div>
          <div className="pk-lyrics">
            <div>
              <p className="pk-lyrics-part">Verse 1</p>
              <p>
                Versteck die Uhren
                <br />
                Sie halten dich alt
                <br />
                Bleib zeitlos stehen
                <br />
                Und merk dir, was bleibt
              </p>
              <p>
                Dann schließ wach die Augen
                <br />
                Ohne Angst
                <br />
                Und lass dich tragen
                <br />
                Wenn du fällst
              </p>
            </div>
            <div>
              <p className="pk-lyrics-part">Chorus</p>
              <p>
                Wir könnten auch
                <br />
                Tiefseetauchen ohne Garantie
                <br />
                Wer wir beim Auftauchen sind
              </p>
              <p>
                Meeresgrundphilosphie
                <br />
                Ist bei Nebel und Wind
                <br />
                Tiefer zu schwimmen
              </p>
            </div>
            <div>
              <p className="pk-lyrics-part">Verse 2</p>
              <p>
                Wer auftaucht
                <br />
                Trägt das Meer mit
                <br />
                Salz auf der Haut
                <br />
                Das zu Hause sucht
              </p>
              <p>
                Wenn dir leise
                <br />
                Was unbestimmtes fehlt
                <br />
                Dann folg 'nem Fluss
                <br />
                Und frag dein Spiegelbild
              </p>
            </div>
          </div>
        </div>

        <div>
          <h2>Downloads</h2>
          <div className="pk-downloads">
            <a href={DRIVE.labelcopy} target="_blank" rel="noopener noreferrer">
              <span className="pk-dl-label">
                <strong>Labelcopy</strong>
                <small>PDF</small>
              </span>
              <IconDownload />
            </a>
            <a href={DRIVE.photos} target="_blank" rel="noopener noreferrer">
              <span className="pk-dl-label">
                <strong>Pressefotos</strong>
                <small>Ordner</small>
              </span>
              <IconDownload />
            </a>
            <a href={DRIVE.logo} target="_blank" rel="noopener noreferrer">
              <span className="pk-dl-label">
                <strong>Logo</strong>
                <small>Ordner</small>
              </span>
              <IconDownload />
            </a>
          </div>
        </div>
      </section>

      <footer className="pk-footer">
        <div>
          <p>Kontakt Label &amp; Management</p>
          <a href="mailto:label@regentaenzer.com">label@regentaenzer.com</a>
          <p>+49 176 500 78 544</p>
        </div>
        <p className="pk-fine">
          © MondWild / Regentänzer · Nur für Presse, Radio und Medienarbeit.
        </p>
      </footer>
    </div>
  );
};
